import React from 'react';
import { BsEye } from 'react-icons/bs';
import { AnimatedContainer } from '../styles';
import { StepIndicator } from '../components/StepIndicator';
import { ComponentUserRegisterProps, stepLabels } from '..';
import {
  BenefitsContainer,
  InfoContainer,
  LineSeparator,
  LinkContainer,
  MonthPriceWrapper,
  PriceContainer,
  PriceItem,
  SignButton,
  SubscriptionContainer,
  SubscriptionContent,
  TextContainer,
  TotalPriceWrapper,
  WarningContainer,
} from './styles';
import watch from '../../../assets/watch.svg';

export const SubscriptionInfo: React.FC<ComponentUserRegisterProps> = ({
  nextPage,
}) => {
  return (
    <AnimatedContainer>
      <StepIndicator activeIndex={0} titles={stepLabels} />
      <h1>Assinatura</h1>
      <InfoContainer>
        <span>Como funciona a assinatura?</span>
        <LinkContainer>
          <BsEye size={16} />
          <span>Contrato de prestação de serviços</span>
        </LinkContainer>
      </InfoContainer>
      <SubscriptionContainer>
        <img src={watch} alt="watch" />
        <SubscriptionContent>
          <h1>Assistente Virtual</h1>
          <PriceContainer>
            <PriceItem>
              <TotalPriceWrapper>
                <div className="priceSection">
                  <span>R$ 290,00 no Cartão/Pix</span>
                </div>
              </TotalPriceWrapper>
              <MonthPriceWrapper>
                <span>
                  R$ 40,00 Mensais{' '}
                  <span className="additionalPrice">+ R$ 205,00</span>
                </span>
              </MonthPriceWrapper>
            </PriceItem>
          </PriceContainer>
          <LineSeparator />
          <h2>Benefícios</h2>
          <BenefitsContainer>
            <div>
              <span>Pulseira inteligente</span>
            </div>
            <div>
              <span>Relatórios de Saúde na palma da mão</span>
            </div>
            <div>
              <span>Aplicativo com Assistente Virtual integrado </span>
            </div>
            <div>
              <span>Acompanhamento com Profissionais da Saúde</span>
            </div>
          </BenefitsContainer>
          <TextContainer>
            <p>
              Você paga <span>R$ 40,00/mês+R$ 250,00</span> do dispositivo
              (apenas na primeira vez). Com a Cinco você pode cancelar quando
              quiser e sem burocracias.
            </p>
          </TextContainer>

          <WarningContainer>
            <p>
              <span>IMPORTANTE:</span> O Modelo da pulseira inteligente pode
              variar da imagem apresentada mediante ao estoque.
            </p>
          </WarningContainer>
        </SubscriptionContent>
      </SubscriptionContainer>
      <SignButton isLoading={false} onClick={() => nextPage()}>
        Assinar
      </SignButton>
    </AnimatedContainer>
  );
};
